import { render, staticRenderFns } from "./CategoryCreate.vue?vue&type=template&id=05c548f2&"
import script from "../../../services/admin/category/category-create.js?vue&type=script&lang=js&"
export * from "../../../services/admin/category/category-create.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports